import { Module } from "./module";

export class ModuleElectronischeFacturatie extends Module {
	public getUseWinfaktPeppol():boolean {
		return this.MetaData["uses-winfakt-peppol"] == "true";
	}
}